
import React from "react"
import ReactDOM from 'react-dom';
import { Helpers } from '../Helpers';
import _ from 'lodash';


export default function TourDetails(props) {
    const { tour } = props.data

    return (
        <div>

            {
                JSON.parse(tour.information).map((information, key) => {

                    return (
                        <div key={key} className="accordion mb-4" id={"tourInformationAccordion" + key} role="tablist" aria-multiselectable="true">
                            <div className="card border-0 bg-transparent">
                                <div className="p-0" role="tab">
                                    <button className="btn btn-flat collapsed p-0 text-decoration-none" type="button" data-toggle="collapse" data-parent={"#tourInformationAccordion" + key} data-target={"#tourInformationCollapse" + key} aria-expanded="true">
                                        <h3 className="mb-0 font-weight-bold body-font body-text-color">
                                            {information.name} <i className="fa fa-angle-down rotate-icon float-none ml-3"></i>
                                        </h3>
                                    </button>
                                </div>
                                <div id={"tourInformationCollapse" + key} className="collapse" role="tabpanel">
                                    <div className="card-body p-0">
                                        <hr className="hr-3px hr-primary hr-short" align="left" />

                                        <div dangerouslySetInnerHTML={{ __html: Helpers.toIconList(information.content, 'fa fa-plus primary-text mr-2') }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }

        </div>

    )
}


const container = document.getElementById('tour-details-w')
if (container) {
    const data = Object.assign({}, container.dataset);

    ReactDOM.render(<TourDetails data={JSON.parse(data.data)} />, container);
}


// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/TourDetails.jsx